import { Component, OnInit, OnDestroy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BaseSlotComponent } from '../base-slot.component';
import { DateRangeExtra } from '../../filter-drawer.types';
import { DateRangePickerComponent } from '../../../date-range-picker/date-range-picker.component';
import dayjs from 'dayjs';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'date-range-slot',
    templateUrl: './date-range-slot.component.html',
    standalone: true,
    imports: [
        DateRangePickerComponent,
        ReactiveFormsModule,
    ],
})
export class DateRangeSlotComponent
    extends BaseSlotComponent
    implements OnInit, OnDestroy
{
    startField!: string;
    endField!: string;
    private destroy$ = new Subject<void>();
    private isInternalUpdate = false;

    ngOnInit(): void {
        super.ngOnInit();
        this.initializeDateRangeSlot();
        // Removed valueChanges formatting to avoid interfering with picker selections
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private initializeDateRangeSlot(): void {
        const extra = this.slot.extra as DateRangeExtra;
        this.startField = extra.startField;
        this.endField = extra.endField;
    }

    // Removed reactive value reformatting to prevent race with picker updates

    getStartValue(): Date | null {
        const startValue = this.formGroup.get(this.startField)?.value;
        return startValue ? dayjs(startValue).toDate() : null;
    }

    getEndValue(): Date | null {
        const endValue = this.formGroup.get(this.endField)?.value;
        return endValue ? dayjs(endValue).toDate() : null;
    }

    onStartDateChange(date: Date | null): void {
        if (date) {
            const formattedDate = dayjs(date).format('YYYY-MM-DD');
            this.formGroup.get(this.startField)?.setValue(formattedDate, { emitEvent: false });
        } else {
            this.formGroup.get(this.startField)?.setValue(null, { emitEvent: false });
        }
    }

    onEndDateChange(date: Date | null): void {
        if (date) {
            const formattedDate = dayjs(date).format('YYYY-MM-DD');
            this.formGroup.get(this.endField)?.setValue(formattedDate, { emitEvent: false });
        } else {
            this.formGroup.get(this.endField)?.setValue(null, { emitEvent: false });
        }
    }

    getValue(): { name: string; value: string }[] {
        const startValue = this.formGroup.get(this.startField)?.value;
        const endValue = this.formGroup.get(this.endField)?.value;

        return [
            {
                name: this.startField,
                value: startValue ? dayjs(startValue).format('YYYY-MM-DD') : '',
            },
            {
                name: this.endField,
                value: endValue ? dayjs(endValue).format('YYYY-MM-DD') : '',
            },
        ];
    }
}
